import { idMeConfig } from '../../config';

import type { IdMeAuthorizationRequest, IdMeAuthorizationResult } from '../../idme.types';

// ─────────────────────────────────────────────────────────────────────────────

export async function promptIdMeAuthorization(params: Params): Promise<IdMeAuthorizationResult> {
  const { authRequest, url } = params;

  try {
    const response = await authRequest.promptAsync(idMeConfig.discovery, { url });

    if (response.type === 'cancel' || response.type === 'dismiss') {
      return { status: 'cancelled' };
    }

    if (response.type === 'error') {
      return {
        status: 'failed',
        code: response.params.error ?? 'unknown_error',
        description: response.params.error_description ?? '',
      };
    }

    if (response.type !== 'success') {
      return { status: 'failed', code: 'no_authorization_code', description: '' };
    }

    return { status: 'authorized', code: response.params.code };
  } catch (error) {
    return {
      status: 'failed',
      code: 'authorization_prompt_failed',
      description: error instanceof Error ? error.message : '',
    };
  }
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = Pick<IdMeAuthorizationRequest, 'authRequest' | 'url'>;
